"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throttle = void 0;

var throttle = function throttle(callback, limit) {
  var wait = false;
  return function () {
    if (!wait) {
      callback.apply(void 0, arguments);
      wait = true;
      setTimeout(function () {
        wait = false;
      }, limit);
    }
  };
};

exports.throttle = throttle;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ0aHJvdHRsZSIsImNhbGxiYWNrIiwibGltaXQiLCJ3YWl0Iiwic2V0VGltZW91dCJdLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvdGhyb3R0bGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IHRocm90dGxlID0gKGNhbGxiYWNrOiBGdW5jdGlvbiwgbGltaXQ6IG51bWJlcikgPT4ge1xuICBsZXQgd2FpdCA9IGZhbHNlO1xuICByZXR1cm4gKC4uLmFyZ3MpID0+IHtcbiAgICBpZiAoIXdhaXQpIHtcbiAgICAgIGNhbGxiYWNrKC4uLmFyZ3MpO1xuICAgICAgd2FpdCA9IHRydWU7XG4gICAgICBzZXRUaW1lb3V0KCgpID0+IHtcbiAgICAgICAgd2FpdCA9IGZhbHNlO1xuICAgICAgfSwgbGltaXQpO1xuICAgIH1cbiAgfTtcbn07XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBTyxJQUFNQSxRQUFRLEdBQUcsU0FBWEEsUUFBVyxDQUFDQyxRQUFELEVBQXFCQyxLQUFyQixFQUF1QztFQUM3RCxJQUFJQyxJQUFJLEdBQUcsS0FBWDtFQUNBLE9BQU8sWUFBYTtJQUNsQixJQUFJLENBQUNBLElBQUwsRUFBVztNQUNURixRQUFRLE1BQVI7TUFDQUUsSUFBSSxHQUFHLElBQVA7TUFDQUMsVUFBVSxDQUFDLFlBQU07UUFDZkQsSUFBSSxHQUFHLEtBQVA7TUFDRCxDQUZTLEVBRVBELEtBRk8sQ0FBVjtJQUdEO0VBQ0YsQ0FSRDtBQVNELENBWE0ifQ==